import {connect} from 'react-redux';

import {sendGoals} from 'client/common/store/actions/metrika';

import {DispatchProps, OwnProps, StateProps} from './types';

import Component from './survey-card';

export default connect<StateProps, DispatchProps, OwnProps>(null, {sendGoals})(Component);
